import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { browserHistory } from 'react-router';
import { OrderActions } from '../../../actions';
import Loader from '../../../components/Loader';
import SubnavBar from '../../../components/SubnavBar';
import TitleBar from '../../../components/TitleBar';

class Outbound extends Component {
  static mapStateToProps = (state) => {
    const { orders } = state;
    return {
      orders
    }
  
  }
  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(OrderActions.getAllOrders());
  }
  render() {
    const { orders } = this.props;
    let content;
  
    if (!orders || orders.fetching || !orders.list) {
      content = <Loader />;
    } else {
      console.log(orders);
    }

    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar />
          <TitleBar title="Outbound Management" />
          <div className="row">
            <div className="col s12">
              {content}
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default connect(Outbound.mapStateToProps)(Outbound);



// WEBPACK FOOTER //
// ./src/containers/Dispatcher/Outbound/index.js